import {
    Component,
    ComponentRef,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import { TextIconComponent } from '../../shared/text-icon/text-icon.component';
import { BaseInputComponent } from '../base-input/base-input.component';
import { TextInputViewType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-input-view',
    templateUrl: './input-view.component.html',
    styleUrls: ['./input-view.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class InputViewComponent extends BaseInputComponent implements OnInit, OnDestroy {
    @Input() input: TextInputViewType;
    @ViewChild('infoTemplate', { static: true, read: ViewContainerRef }) infoTemplate: ViewContainerRef;
    hasMaxChars: boolean;
    private infoComponent: ComponentRef<TextIconComponent>;
    constructor(private questionStateService: QuestionStateService) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
        this.hasMaxChars = this.input.maxChars > 0;
        if (this.input.info && this.infoTemplate) {
            this.infoComponent = this.infoTemplate.createComponent(TextIconComponent);
            this.infoComponent.instance.tooltip = this.input.info;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.infoComponent) {
            this.infoComponent.destroy();
        }
    }
}
